import React, { useContext } from "react";
import Stats from "../blocks/stats";
import UserContext from "../components/TheUser";
import Breadcrums from "../components/breadcrums";
import PageTitle from "../components/pageTitle";
import classNames from "classnames";
import { sectionClass } from "../constants/common";

const breadcrumLinks = [{ name: "Dashboard", href: "/dashboard-analytics", current: true }];

export default function DashboardAnalytics() {
    const userData = useContext(UserContext);

    return (
        <main>
            <Breadcrums breadcrumLinks={breadcrumLinks} module={"Dashboard"} />
            <PageTitle title="Dashboard" preSummary="Operational Excellence Dashboard" summary="Snapshot Report Effective from 01 Jan 2025">
                {/* , July 2023 */}
            </PageTitle>

            <section className={classNames(sectionClass)}>
                <Stats />
            </section>

            {/* <section>
                <h1>{JSON.stringify(userData)}</h1>
            </section> */}
        </main>
    );
}
